/**
 * 803systems.com for now: the BlueHQ graphic and "coming soon", with a small Sign in link. The full page
 * (BlueLanding) stays in the code until the owner picks what goes on it.
 */
import { useEffect } from 'react';
import { useRouter } from './router.tsx';
import { BlueLogo } from './BlueMark.tsx';

export function ComingSoon() {
  const { navigate } = useRouter();
  useEffect(() => {
    const prev = document.title;
    document.title = 'BlueHQ · 803 Systems';
    return () => {
      document.title = prev;
    };
  }, []);
  return (
    <div className="cs-page">
      <main className="cs-main">
        <BlueLogo className="cs-logo" />
        <p className="cs-tag">One platform. A safer tomorrow.</p>
        <span className="cs-rule" aria-hidden="true" />
        <p className="cs-verbs">
          Report <i aria-hidden="true">|</i> Enforce <i aria-hidden="true">|</i> Serve <i aria-hidden="true">|</i> Manage <i aria-hidden="true">|</i> Connect
        </p>
        <p className="cs-built">Built for those who serve.</p>
        <p className="cs-soon">A comprehensive records management system — coming soon.</p>
      </main>
      <footer className="cs-foot">
        <span>© {new Date().getFullYear()} 803 Systems, LLC</span>
        <a
          href="/signin"
          onClick={(e) => {
            e.preventDefault();
            navigate('/signin');
          }}
        >
          Sign in
        </a>
      </footer>
    </div>
  );
}
